module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/map-list/map-list.component.scss
// module id = ./src/app/widgets/widget-detail/map-list/map-list.component.scss
// module chunks = main